document.addEventListener("DOMContentLoaded", function () {
  // All swiper slides
  const slides = document.querySelectorAll(
    ".product-single__thumbnails .swiper-slide"
  );

  slides.forEach((slide) => {
    // Click event for each slide
    slide.addEventListener("click", function () {
      // Remove class from all
      slides.forEach((s) => s.classList.remove("slide-active"));
      // Add to the clicked one
      this.classList.add("slide-active");
    });
  });

  // ✅ Optional: On page load, add any other custom class (like slide-active) to the active one
  const activeSlide = document.querySelector(
    ".product-single__thumbnails .swiper-slide-active"
  );
  if (activeSlide) {
    activeSlide.classList.add("slide-active"); // If you want separate custom class
  }
});
